/* eslint-disable react-hooks/exhaustive-deps */
import {
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons";
import CommonToast from "../../../../components/_utils/CommonToast";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast";
import {
  errorcode,
  GlobalConfiguration,
  IntervalConfiguration,
  RejectReasonLength,
} from "../../../../utils/configurationProvider.js";
import useCategories from "../../../../utils/useCategories.js";

import OwnerAccountDetailsPopUp from "../../../../components/Accounts/OwnerAccountDetailsPopUp";
import TaxAccountDetailsPopup from "../../../../components/Accounts/TaxAccount/TaxAccountDetailsPopup/index.jsx";
import CommonTimeLineCard, {
  addLifeCycleStatus,
} from "../../../../components/CommonTimeLineCard";
import FullScreen from "../../../../components/FullScreen";
import Loader from "../../../../components/Loader/Index";
import CommonBankLogo from "../../../../components/_utils/CommonBankLogo";
import Chips from "../../../../components/_utils/CommonButtons/Chips";
import SwitcherTabs from "../../../../components/_utils/CommonButtons/SwitcherTabs";
import TopNavSmallButton from "../../../../components/_utils/CommonButtons/TopNavSmallButton";
import CommonContainerCard from "../../../../components/_utils/CommonContainerCard";
import CommonDetailCard from "../../../../components/_utils/CommonDetailCard";
import CommonInfoBox from "../../../../components/_utils/CommonInfoBox";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import SmallPopupWithInput from "../../../../components/_utils/CommonSmallPopupWithInput/index.jsx";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber/index.js";
import MediumImagePopup from "../../../../components/_utils/MediumImagePopup";
import TimelineStatusBar from "../../../../components/_utils/TimelineCommonComponents/TimelineStatusBar";
import TimelinePopupContent from "../../../../components/_utils/TimelinePopupContent";
import TitleSubtitlePair from "../../../../components/_utils/TitleSubtitlePair";
import { disableSwitcher } from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import {
  approveTdsTransaction,
  rejectTdsTransaction,
} from "../../../../redux/features/transactions/taxTransaction/taxTransactionApproval.js";
import { fetchTdsTransactionDetails } from "../../../../redux/features/transactions/taxTransaction/taxTransactionDetails.js";
import {
  taxTxnNewAddLabel,
  taxTxnRemoveLabel,
} from "../../../../redux/features/transactions/taxTransaction/taxTransactionViewAll.js";
import formatCurrency from "../../../../utils/CurrencyFormater.js";
import ISO_DataFormatter from "../../../../utils/ISO_DataFormatter";
import formatDateViewAll from "../../../../utils/formatDateViewAll.js";
import { default as TEXT } from "../../../../utils/globalText.js";
import TaxationTransactionViewAll from "../TaxationTransactionViewAll/index.jsx";

const TaxationTransactionDetails = ({
  tax_txn_id,
  closeBeneTxnDetailModal,
  typePopup,
  typeMulti,
  typeSingle,
}) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const previousStatus = useLocation()?.state?.options?.state;
  const { typeSingleMob } = location.state || {};

  const cardRefs = useRef({});
  const cardRefsDist = useRef({});
  const leftContentRef = useRef(null);
  const labelActionDispatchedRef = useRef(false);

  const [labels, setLabels] = useState([]);
  const [entityId, setEntityId] = useState("");
  const [loading, setLoading] = useState(true);
  const [infoBox, setInfoBox] = useState(false);
  const [btnClicked, setbtnClicked] = useState({});
  const [isTaxAccId, setTaxAccId] = useState("");
  const [alertPopUp, setAlertPopUp] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [labelDetails, setLabelDetails] = useState([]);
  const [selectedImage, setSelectedImage] = useState({});
  const [rightHeight, setRightHeight] = useState("auto");
  const [networkError, setNetworkError] = useState(false);
  const [openImageUrl, setOpenImageUrl] = useState(false);
  const [animationClass, setAnimationClass] = useState("");
  const [declineReason, setDeclineReason] = useState("");
  const [viewTxnDetails, setviewTxnDetails] = useState([]);
  const [isCategoryName, setIsCategoryName] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [taxTxnDetailsID, settaxTxnDetailsID] = useState("");
  const [showLabelsPopup, setShowLabelsPopup] = useState(false);
  const [openTransHistory, setOpenTransHistory] = useState(false);
  const [showDeclineModal, setShowDeclineModal] = useState(false);
  const [OwnerDetailpop, setOwnerDetailpop] = useState(false);
  const [opentimelinepopup, SetopenTimelinePopup] = useState(false);

  const [showAssignedLabels, setShowAssignedLabels] = useState(false);
  const [taxTxnAccountDetailpop, setTaxAccountDetailpop] = useState(false);
  const [showApprovalTimeline, setShowApprovalTimeline] = useState(false);
  const [showDistributionTimeline, setShowDistributionTimeline] =
    useState(false);
  const [showDetails, setShowDetails] = useState(
    typeSingle ||
      typeSingleMob === "Additional_Details" ||
      typeMulti === "MultiApproval_Session_Data"
      ? false
      : true,
  );
  const [showAdditionalDetails, setShowAdditionalDetails] = useState(
    typeSingle ||
      typeMulti === "MultiApproval_Session_Data" ||
      typeSingleMob === "Additional_Details"
      ? true
      : false,
  );

  const [index, setIndex] = useState(
    showDetails
      ? GlobalConfiguration?.lengthCheckZero
      : showAdditionalDetails
        ? GlobalConfiguration?.lengthCheckOne
        : showAssignedLabels
          ? GlobalConfiguration?.lengthCheckTwo
          : GlobalConfiguration?.lengthCheckZero,
  );
  const [prevIndex, setPrevIndex] = useState(
    GlobalConfiguration?.lengthCheckZero,
  );

  // const [openApprovalTimeline, setOpenApprovalTimeline] = useState(
  //   Array(
  //     viewTxnDetails?.[0]?.logs?.length || GlobalConfiguration?.lengthCheckZero,
  //   ).fill(false),
  // );

  // const [openDistributionTimeline, setOpenDistributionTimeline] = useState(
  //   Array(
  //     viewTxnDetails?.[0]?.distribution_logs?.length ||
  //       GlobalConfiguration?.lengthCheckZero,
  //   ).fill(false),
  // );

  const [openApprovalTimeline, setOpenApprovalTimeline] = useState([]);
  const [openDistributionTimeline, setOpenDistributionTimeline] = useState([]);

  const resetAllTimelines = () => {
    setOpenApprovalTimeline(
      new Array(
        viewTxnDetails?.[GlobalConfiguration.lengthCheckZero]?.logs?.length ||
          GlobalConfiguration.lengthCheckZero,
      ).fill(false),
    );

    setOpenDistributionTimeline(
      new Array(
        viewTxnDetails?.[GlobalConfiguration.lengthCheckZero]?.distribution_logs
          ?.length || 0,
      ).fill(false),
    );
  };

  const { services } = useSelector((state) => state.refreshToken);
  const { tdsTransactionDetailsLoading, tdsTransactionDetailsData } =
    useSelector((state) => state.tdsTransactionDetails);

  const categoryMapper = useCategories();

  const hasConfidential = services?.includes("VConfidentialTxn");

  useLayoutEffect(() => {
    if (index !== prevIndex) {
      const direction =
        index > prevIndex ? "animate-slide-next" : "animate-slide-prev";

      setAnimationClass(direction);
      setPrevIndex(index);
    }
  }, [index]);

  const PopupcloseIcons = () => {
    resetAllTimelines();
    SetopenTimelinePopup(false);
    setShowApprovalTimeline(false);
    setShowDistributionTimeline(false);
  };

  const actionRestricted = () => {
    CommonToast({
      text: "Action restricted in popup mode.",
      icon: ICONS?.ERROR_WHITE_CIRCLE,
      variant: "var(--error)",
    });
  };

  const handleBeneAccountClick = () => {
    const isServiceMissing = services.includes("BVAccount");

    if (typePopup) {
      actionRestricted();
      return;
    }

    if (!isServiceMissing) {
      navigate("/feature_not_assigned", {
        state: { unavailableService: "BVAccount" },
      });
    } else {
      setTaxAccountDetailpop(true);
    }
  };

  const labelTxnIds = [taxTxnDetailsID || id || tax_txn_id].filter(Boolean);

  const handleTimelinePopup = () => {
    if (typePopup) {
      actionRestricted();
    } else {
      SetopenTimelinePopup(true);
      setShowApprovalTimeline(true);
      if (!showApprovalTimeline) {
        setShowDetails(true);
        setShowAdditionalDetails(false);
        setShowDistributionTimeline(false);
        setShowAssignedLabels(false);
      }
      setOpenDistributionTimeline(false);
    }
  };

  const handleInputChange = (event) => {
    const value = event.target.value;

    const sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");

    const limitedValue = sanitizedValue.slice(
      GlobalConfiguration.lengthCheckZero,
      RejectReasonLength.lengthOfDecline,
    );

    setDeclineReason(limitedValue);
  };

  const openTransactionHistory = () => {
    setOpenTransHistory(true);
  };

  const closeTransactionHistory = () => {
    setOpenTransHistory(false);
    setIsCategoryName("");
    setTaxAccId("");
  };

  const toggleDetails = () => {
    setShowDetails(true);
    setShowAdditionalDetails(false);
    setShowAssignedLabels(false);
  };

  const toggleAdditionalDetails = () => {
    setShowAdditionalDetails(true);
    setShowDetails(false);
    setShowAssignedLabels(false);
  };

  const toggleAssignedLabels = () => {
    setShowAssignedLabels(true);
    setShowAdditionalDetails(false);
    setShowDetails(false);
  };

  const handleApproveTransaction = async (id) => {
    setbtnClicked((prev) => ({
      ...prev,
      [id]: "Approve",
    }));
    setShowLoader(true);
    UniversalRefreshToast("Approving transaction");
    setTimeout(() => {
      toast.dismiss();
    }, IntervalConfiguration.intervalMedium);

    let res;
    if (typePopup) {
      res = await dispatch(approveTdsTransaction(tax_txn_id));
    } else {
      res = await dispatch(approveTdsTransaction(id));
    }

    if (res?.payload === undefined) {
      setNetworkError(
        "An error occured while taking action on this transaction",
      );
      setTimeout(() => {
        CommonToast({
          text: "An error occured while taking action on this transaction",
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }, IntervalConfiguration?.intervalExtraLarge);
      setShowLoader(false);
    } else if (res?.payload?.errors) {
      let errorMessage =
        res?.payload?.errors?.[0]?.reason || "Something went wrong";
      CommonToast({
        text: errorMessage,
        icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
        variant: "var(--error)",
        buttonNeeded: false,
      });
      setShowLoader(false);
    } else if (res?.payload?.errors?.user_unauthorized?.[0]) {
      setTimeout(() => {
        navigate("/feature_not_assigned", {
          state: {
            unavailableService: "VBeneficiaryTxn",
          },
        });
      }, IntervalConfiguration?.intervalExtraLarge);
      setShowLoader(false);
    } else if (
      res?.payload?.status === false ||
      res.type === "fetchTdsTransactionActionable/rejected"
    ) {
      if (
        res?.payload?.errors?.base[0]?.errors &&
        res?.payload?.errors?.base[0]?.errors[0]?.reason
      ) {
        const error_msg = res?.payload?.errors?.base[0]?.errors[0]?.reason;
        if (!Array.isArray(error_msg)) {
          setErrorMessage(error_msg);
          setTimeout(() => {
            CommonToast({
              text: error_msg,
              icon: ICONS?.ERROR_WHITE_CIRCLE,
              variant: "var(--error)",
              btnProps: {
                isDisabled: false,
                enabledTextColor: "var(--text-primary)",
                enabledBgColor: "var(--primary-bg)",
              },
            });
          }, IntervalConfiguration?.intervalMedium);
          setShowLoader(false);
        } else {
          setErrorMessage(res.payload.errors.base[0].errors[0].reason[0]);
          if (
            res.payload.errors.base[0].errors[0].reason.length >=
            GlobalConfiguration?.lengthCheckOne
          ) {
            let msgs = res.payload.errors.base[0].errors[0].reason;
            msgs.forEach((error) => {
              if (res?.payload?.status === false) {
                setTimeout(() => {
                  CommonToast({
                    text: error,
                    icon: ICONS?.ERROR_WHITE_CIRCLE,
                    variant: "var(--error)",
                    btnProps: {
                      isDisabled: false,
                      enabledTextColor: "var(--text-primary)",
                      enabledBgColor: "var(--primary-bg)",
                    },
                  });
                }, IntervalConfiguration?.intervalMedium);
              }
            });
          }
          setShowLoader(false);
        }
      } else if (
        res?.payload?.errors?.base[0]?.reason &&
        res?.payload?.errors?.base[0]?.reason[0]
      ) {
        setErrorMessage(res?.payload?.errors?.base[0]?.reason[0]);
        setTimeout(() => {
          CommonToast({
            text: res?.payload?.errors?.base[0]?.reason[0],
            icon: ICONS?.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        }, IntervalConfiguration?.intervalMedium);
        setShowLoader(false);
      } else if (res?.payload?.errors?.base[0]) {
        setErrorMessage(res.payload.errors.base[0]);
        setTimeout(() => {
          CommonToast({
            text: res.payload.errors.base[0],
            icon: ICONS?.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        }, IntervalConfiguration?.intervalExtraLarge);
        setShowLoader(false);
      }
    } else {
      const approvedLifecycle =
        res?.payload?.transactions?.[GlobalConfiguration.lengthCheckZero]
          ?.lifecycle_status;
      const approvedDistributionFromRes =
        res?.payload?.transactions?.[GlobalConfiguration.lengthCheckZero]
          ?.distribution_lifecycle_status;

      const approvedDistribution =
        approvedDistributionFromRes ??
        (approvedLifecycle === "approved" ? "created" : undefined);

      const updatedData = tdsTransactionDetailsData?.transaction?.map(
        (data) => {
          const resolvedLifecycle = approvedLifecycle ?? data?.lifecycle_status;
          const resolvedDistribution =
            approvedDistribution ?? data?.distribution_lifecycle_status;

          const uiState = addLifeCycleStatus({
            lifecycle_status: resolvedLifecycle,
            distribution_lifecycle_status: resolvedDistribution,
            services,
          });

          return {
            ...data,
            lifecycle_status: resolvedLifecycle,
            distribution_lifecycle_status: resolvedDistribution,
            last_updated_status:
              res?.payload?.transactions?.[0]?.last_updated_status,
            last_updated_user_id:
              res?.payload?.transactions?.[0]?.last_updated_user_id,
            ...uiState,
          };
        },
      );
      setviewTxnDetails(updatedData);

      if (res?.payload?.status === true) {
        setTimeout(() => {
          CommonToast({
            text: "Transaction approved successfully.",
            icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
            variant: "var(--success)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        }, IntervalConfiguration?.intervalMedium);
        if (typePopup) {
          await dispatch(fetchTdsTransactionDetails(tax_txn_id));
        } else {
          await dispatch(fetchTdsTransactionDetails(id));
        }
      }
      setbtnClicked((prev) => ({
        ...prev,
        [id]: "none",
      }));
      setShowLoader(false);
      // if (typePopup) {
      //   setTimeout(() => {
      //     closeBeneTxnDetailModal();
      //     window.location.reload();
      //   }, IntervalConfiguration.intervalExtraLarger);
      // }
    }
  };

  const handleDeclinedDetails = (id) => {
    setbtnClicked((prev) => ({
      ...prev,
      [viewTxnDetails?.[0]?.txn_id]: "Reject",
    }));
    settaxTxnDetailsID(id);
    setShowDeclineModal(true);
  };

  const updateAllAccounts = (updatedAccounts) => {
    setviewTxnDetails(updatedAccounts);
  };

  const showAmountInfo = () => {
    setInfoBox(!infoBox);
  };

  const closeModal = () => {
    if (infoBox || showDeclineModal) {
      setInfoBox(false);
      setShowDeclineModal(false);
    }
  };

  const additional_data =
    tdsTransactionDetailsData?.transaction[0]?.additional_data;

  const validItems = additional_data?.data ? additional_data?.data : [];
  const attachments = validItems.filter(
    (obj) =>
      (obj.data_type.toLowerCase() === "hyperlink" ||
        obj.data_type === "File" ||
        obj.data_type === "upload") &&
      "value" in obj,
  );
  const loginid = JSON.parse(sessionStorage.getItem("response"));

  const handleDistributionClick = () => {
    if (typePopup) {
      actionRestricted();
    } else {
      SetopenTimelinePopup(true);
      setShowDistributionTimeline(true);
      if (!showDistributionTimeline) {
        setShowDetails(true);
        setShowAdditionalDetails(false);
        setShowApprovalTimeline(false);
        setShowAssignedLabels(false);
      }
      setOpenApprovalTimeline(false);
    }
  };

  const finalize = () => {
    setShowLoader(false);
    setDeclineReason("");
  };

  const handleApprovalTimeline = (index) => {
    setOpenApprovalTimeline((prevOpenDivs) => {
      if (!Array.isArray(prevOpenDivs)) {
        return [];
      }
      const newOpenDivs = [...prevOpenDivs];
      newOpenDivs[index] = !newOpenDivs[index];
      return newOpenDivs;
    });
    setOpenDistributionTimeline(
      Array(viewTxnDetails?.[0]?.distribution_logs?.length).fill(false),
    );
    if (!openApprovalTimeline[index]) {
      setTimeout(() => {
        cardRefs.current[index]?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, IntervalConfiguration.intervalExtraSmall);
    }
  };

  const handleDistributionTimeline = (index) => {
    setOpenDistributionTimeline((prevOpenDivs) => {
      if (!Array.isArray(prevOpenDivs)) {
        return [];
      }
      const newOpenDivs = [...prevOpenDivs];
      newOpenDivs[index] = !newOpenDivs[index];
      return newOpenDivs;
    });
    setTimeout(() => {
      if (cardRefsDist.current[index]) {
        cardRefsDist.current[index].scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, IntervalConfiguration.intervalExtraSmall);
  };

  const handleReject = async (id, reason) => {
    setShowDeclineModal(false);
    try {
      if (
        services?.find(
          (service) => service === "ATDSTransaction" || service === "Admin",
        ) !== undefined
      ) {
        // Token Check
        if (!sessionStorage.getItem("q2p_token")) {
          return;
        }

        setShowLoader(true);

        const apiCall = rejectTdsTransaction({
          id,
          accountIdData: reason,
        });

        const result = await dispatch(apiCall);
        const payload = result?.payload;

        // wait for loader animation
        await new Promise((resolve) =>
          setTimeout(resolve, IntervalConfiguration.intervalExtraLarge),
        );

        if (payload?.status === errorcode.errorFailed) {
          CommonToast({
            text: payload?.error || "Something went wrong",
            icon: ICONS?.INFO_FILLED,
            variant: "var(--error)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
          return finalize();
        }

        if (payload?.errors?.user_unauthorized?.[0]) {
          navigate("/feature_not_assigned", {
            state: { unavailableService: "ATDSTransaction, Admin" },
          });
          return finalize();
        }

        // SINGLE approval flow
        const updatedData = viewTxnDetails?.map((item) => {
          if (item.txn_id !== id) return item;

          const tx = payload?.transactions?.[0];
          let lifecycleStatus = "error";
          let errorMessage = "";

          // lifecycle status logic
          if (payload?.status === true) {
            lifecycleStatus =
              tx?.lifecycle_status === "rejected"
                ? "rejected"
                : tx?.lifecycle_status === "pending"
                  ? "pendingOne"
                  : "error";
          }

          if (payload?.errors?.base?.[0]?.errors) {
            const errors = payload.errors.base[0].errors;
            errorMessage = errors[0];

            errors.forEach((msg) => {
              if (payload?.status === false) {
                CommonToast({
                  text: msg,
                  icon: ICONS?.INFO_FILLED,
                  variant: "var(--error)",
                  btnProps: {
                    isDisabled: false,
                    enabledTextColor: "var(--text-primary)",
                    enabledBgColor: "var(--primary-bg)",
                  },
                });
              }
            });
          } else if (payload?.errors?.base?.[0]) {
            errorMessage = payload.errors.base[0];
          }

          return {
            ...item,
            lifecycle_status:
              item.lifecycle_status === "pending" && payload?.status === true
                ? lifecycleStatus
                : "error",
            rejected: true,
            rejection_reason: reason,
            error: payload?.status === false ? "true" : "false",
            message: payload?.status === false ? errorMessage : "",
          };
        });

        updateAllAccounts(updatedData);

        if (payload?.status === false) {
          const err =
            payload?.errors?.base?.[0]?.errors?.[0] ||
            payload?.errors?.base?.[0] ||
            "Error occurred";
          CommonToast({
            text: err,
            icon: ICONS?.INFO_FILLED,
            variant: "var(--error)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        } else {
          CommonToast({
            text: "Transaction rejected successfully.",
            icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
            variant: "var(--success)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        }

        await dispatch(fetchTdsTransactionDetails(id));

        finalize();
      } else {
        navigate("/feature_not_assigned", {
          state: {
            unavailableService: "ATDSTransaction, Admin",
          },
        });
      }
    } finally {
    }
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const recordIds = toArray(labelTxnIds);
    const res = await dispatch(
      taxTxnNewAddLabel({
        record_ids: recordIds,
        labels: labelsToAssign,
      }),
    );
    if (taxTxnNewAddLabel?.fulfilled?.match(res)) {
      toast.dismiss();

      CommonToast({
        text: "Labels assigned successfully.",
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await fetchData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (taxTxnNewAddLabel?.rejected?.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.INFO_FILLED,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    if (taxTxnNewAddLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const recordIds = toArray(labelTxnIds);
    const res = await dispatch(
      taxTxnRemoveLabel({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );
    if (taxTxnRemoveLabel?.fulfilled?.match(res)) {
      toast.dismiss();

      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await fetchData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (taxTxnRemoveLabel?.rejected?.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.INFO_FILLED,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    if (taxTxnRemoveLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const fetchData = useCallback(async () => {
    setLoading(true);

    try {
      let response;

      if (typePopup) {
        response = await dispatch(fetchTdsTransactionDetails(tax_txn_id));
        setLabelDetails(response?.payload?.transaction?.[0]?.labels || []);
      } else {
        response = await dispatch(fetchTdsTransactionDetails(id));
        setLabelDetails(response?.payload?.transaction?.[0]?.labels || []);
      }

      if (response?.error?.message === "Request failed with status code 404") {
        navigate("*");
      }
    } catch (error) {
      console.error("Failed to load the transaction details", error);
    } finally {
      setLoading(false);
    }
  }, [
    tdsTransactionDetailsLoading,
    dispatch,
    typePopup,
    tax_txn_id,
    id,
    navigate,
  ]);

  useEffect(() => {
    dispatch(disableSwitcher());
  }, []);

  useEffect(() => {
    fetchData();
    let availableLabels = sessionStorage?.getItem("taxTxnAvailableLabels");
    const parsedLabels = JSON?.parse(availableLabels);
    setLabels(parsedLabels);
  }, [id]);

  const handleClose = () => {
    setShowLabelsPopup(false);
    if (!labelActionDispatchedRef.current) return;
    labelActionDispatchedRef.current = false;
    fetchData();
  };

  useEffect(() => {
    if (tdsTransactionDetailsData) {
      const uiState = addLifeCycleStatus({
        lifecycle_status:
          tdsTransactionDetailsData?.transaction[0]?.lifecycle_status,
        distribution_lifecycle_status:
          tdsTransactionDetailsData?.transaction[0]
            ?.distribution_lifecycle_status,
        services,
        previousStatus: previousStatus,
      });

      const newData = tdsTransactionDetailsData?.transaction?.map(
        (account) => ({
          ...account,
          loading: false,
          error: false,
          message: "",
          last_updated_user_id_check: false,
          ...uiState,
        }),
      );

      setviewTxnDetails(newData);

      const newEntityId =
        tdsTransactionDetailsData?.transaction?.[0]?.entity_id;
      const newTxnId = tdsTransactionDetailsData?.transaction?.[0]?.txn_id;

      if (entityId !== newEntityId) {
        setEntityId(newEntityId);
      }

      if (taxTxnDetailsID !== newTxnId) {
        settaxTxnDetailsID(newTxnId);
      }
    }
  }, [tdsTransactionDetailsData]);

  useEffect(() => {
    if (leftContentRef.current) {
      setRightHeight(leftContentRef.current.offsetHeight);
    }
  }, [viewTxnDetails]);

  const [isFocused, setIsFocused] = useState(false);
  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === 0) return "default";

    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  return (
    <>
      {" "}
      {showLabelsPopup && (
        <div
          onClick={(e) => {
            e.stopPropagation();
            setShowLabelsPopup(true);
          }}
          className="fixed left-left-base w-width-full top-top-base h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal"
        >
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated transactions."
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={labels}
            setLabels={setLabels}
            LabelAccounts={id}
            isLabelPopupOpen={showLabelsPopup}
            filteredData={tdsTransactionDetailsData?.transaction}
            labelActionDispatchedRef={labelActionDispatchedRef}
            onClose={handleClose}
            loading={loading}
            setLoading={setLoading}
            handleAssignLabels={handleAssignLabelsProp}
            handleUnassignLabels={handleUnassignLabelsProp}
            type="details"
          />
        </div>
      )}
      {taxTxnAccountDetailpop && (
        <>
          <div className="fixed left-left-base w-width-full top-top-base h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal">
            <TaxAccountDetailsPopup
              closeBeneAccountDetailModal={() => {
                setTaxAccountDetailpop(false);
              }}
              headerTitle={`${
                viewTxnDetails[0]?.tds_account_approval_status === "pending"
                  ? ""
                  : "Tax account details"
              }`}
              tax_account_id={viewTxnDetails[0]?.tds_account_id}
              type="tax_account_detail_modal"
            />
          </div>
        </>
      )}
      {openImageUrl && (
        <>
          <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <MediumImagePopup
              image={selectedImage}
              closehandleFunction={() => {
                setOpenImageUrl(false);
              }}
            />
          </div>
        </>
      )}
      {showDeclineModal && (
        <div className="fixed top-top-base left-left-base w-full h-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal">
          <SmallPopupWithInput
            headerTitle={TEXT.REJECT_REASON_LABEL}
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            secondHeaderTitle={TEXT.REJECTION_REASON_PROMPT}
            secondHeaderFontWeight="normal"
            secondHeaderFontColor="text-secondary"
            secondHeaderTextSize="font-xs"
            inputPlaceholder={TEXT.REASON_10_150_CHAR}
            inputVariant={computeVariant(declineReason, isFocused)}
            inputOnFocus={(e) => setIsFocused(true)}
            inputOnBlur={(e) => setIsFocused(false)}
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              if (!showLoader) {
                handleInputChange(e);
              }
            }}
            inputValue={declineReason}
            inputFontKind="small"
            inputIsFullWidth={true}
            btnOneText={TEXT.CANCEL}
            btnOneHandleFunction={() => {
              if (!showLoader) {
                setShowDeclineModal(false);
                setDeclineReason("");

                setbtnClicked((prev) => ({
                  ...prev,
                  [taxTxnDetailsID]: null,
                }));
              }
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnOneIsDisabled={showLoader}
            btnTwoText={TEXT.REJECT}
            btnTwoHandleFunction={() => {
              if (
                !declineReason ||
                declineReason.length <
                  GlobalConfiguration.owneraccountnormalLength ||
                showLoader
              ) {
                return;
              }

              handleReject(taxTxnDetailsID, declineReason);
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              !declineReason ||
              declineReason.length <
                GlobalConfiguration.owneraccountnormalLength
            }
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={showLoader ? true : false}
            btnTwoIsLoading={showLoader ? true : false}
            btnTwoHoverOption="black"
            btnTwoInActiveVariantNeeded={true}
          />
        </div>
      )}
      {opentimelinepopup && (
        <>
          <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <LargePopupRedirect
              headerTitle="Transaction timeline"
              headerFontWeight="semibold"
              headerFontColor="text-primary"
              headertextSize="font-md"
              closeiconenabledBgColor="var(--primary-nav)"
              closeiconisLoading={false}
              closeiconhandleFunction={PopupcloseIcons}
              closeicon={ICONS?.CLOSE}
              closeiconhoverOption="white"
              closeiconbtnType={"button"}
              closeiconisDisabled={false}
              closeicondisabledBgColor={""}
              closeiconbuttonRef={null}
              closeicontitle={"Close"}
              btnType={"button"}
              handleFunction={() => {}}
              enabledBgColor={"var(--positive-act)"}
              hoverOption={"dark"}
              outLineColor={""}
              enabledTextColor={"var(--text-primary)"}
              fullWidthRequired={false}
              isDisabled={false}
              disabledTextColor={""}
              disabledBgColor={""}
              isLoading={false}
              buttonRef={null}
              inActiveVariantNeeded={false}
              isLoaderNeeded={false}
              isscrollRequired={true}
            >
              <TimelinePopupContent
                logsData={viewTxnDetails}
                handleApprovalClick={handleTimelinePopup}
                handleDistributionClick={handleDistributionClick}
                showDistributionRightIcon={false}
                showApprovalLeftIcon={false}
                showApprovalTimeline={showApprovalTimeline}
                showDistributionTimeline={showDistributionTimeline}
                openApprovalTimeline={openApprovalTimeline}
                openDistributionTimeline={openDistributionTimeline}
                handleApprovalTimeline={handleApprovalTimeline}
                handleDistributionTimeline={handleDistributionTimeline}
                setOpenDistributionTimeline={setOpenDistributionTimeline}
                setOpenApprovalTimeline={setOpenApprovalTimeline}
                cardType={"double"}
                popUpMode={true}
              />
            </LargePopupRedirect>
          </div>
        </>
      )}
      {alertPopUp && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-max bg-opacity-dark-opacity">
          <FullScreen
            type={"txn"}
            id={tax_txn_id}
            setAlertPopUp={setAlertPopUp}
          />
        </div>
      )}
      <div
        className={`bg-primary-bg overflow-x-hidden ${showDeclineModal || openTransHistory ? "overflow-y-hidden" : "overflow-y-auto"}`}
        style={{
          height: typePopup ? "var(--height-full)" : "var(--full-height)",
        }}
        onClick={closeModal}
      >
        {loading || tdsTransactionDetailsLoading ? (
          <div
            className={`bene-detail-loader-box m-auto justify-center items-center flex ${typePopup ? "" : "pt-padding-xl"}`}
          >
            <Loader />
          </div>
        ) : (
          <>
            {!typePopup ? (
              <div className="Qsmd:flex hidden h-navbar-breadcrumb-height bg-primary-nav w-width-full"></div>
            ) : null}

            <div className={`beneTxnDetailsPage ${typePopup ? "" : ""}`}>
              {OwnerDetailpop && (
                <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-Primary-black bg-opacity-dark-opacity">
                  <OwnerAccountDetailsPopUp
                    closeBeneAccountDetailModal={() => {
                      setOwnerDetailpop(false);
                    }}
                    Remibursement_owneraccount_id={
                      tdsTransactionDetailsData?.transaction?.[
                        GlobalConfiguration.lengthCheckZero
                      ]?.owner_account_id
                    }
                    type={"reimburseowner_details"}
                  />
                </div>
              )}

              {openTransHistory && (
                <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
                  <LargePopupRedirect
                    headerTitle={"Transaction history"}
                    headersubtext={
                      "All transactions related to the tax account are listed below."
                    }
                    closeiconenabledBgColor="var(--primary-nav)"
                    closeiconisLoading={false}
                    closeiconhandleFunction={() => closeTransactionHistory()}
                    closeicon={ICONS?.CLOSE}
                    closeiconhoverOption="white"
                    closeiconbtnType={"button"}
                    closeiconisDisabled={false}
                    closeicondisabledBgColor={""}
                    closeiconbuttonRef={null}
                    closeicontitle={"Close"}
                    btnType={"button"}
                    enabledBgColor={"var(--negative-act)"}
                    hoverOption={"dark"}
                    outLineColor={""}
                    enabledTextColor={"var(--text-primary)"}
                    fullWidthRequired={false}
                    isDisabled={false}
                    disabledTextColor={""}
                    disabledBgColor={""}
                  >
                    <TaxationTransactionViewAll
                      txnHistoryid={isTaxAccId}
                      type={"tax_txnViewAll_popup"}
                      isCategoryName={isCategoryName}
                      closeReimburseTxnDetailsModal={() =>
                        closeTransactionHistory()
                      }
                      openTransHistory={openTransHistory}
                    />
                  </LargePopupRedirect>
                </div>
              )}
              <div
                className={`fixed top-top-base left-left-base mt-margin-base w-width-full rounded-bl-border-radius-md rounded-br-border-radius-md z-z-index-header bg-primary-nav shadow-box-shadow-bottom ${
                  typePopup ? "hidden" : "lg:hidden"
                } block`}
              >
                {" "}
                <TopNavComponent
                  topNavHeader={"Tax"}
                  isFormattingNotRequired
                  topNavSubText={TEXT?.TRANSACTION_DETAILS}
                  handleBack={(e) => {
                    navigate(GlobalConfiguration.navigate_back);
                  }}
                />
              </div>

              <div
                className={`h-auto w-width-full bg-primary-nav ${typePopup ? "pt-padding-base" : "Qsmd:pt-padding-base pt-padding-lg"} `}
              >
                <div
                  className={`bene-txn-account-primary-details  ${typePopup ? "" : "Qsmd:pt-padding-base pt-padding-xl"}`}
                >
                  {tdsTransactionDetailsData?.transaction?.map((account) => (
                    <div
                      key={account?.txn_id}
                      className={`w-width-full h-auto bg-primary-nav ${
                        typePopup
                      }`}
                    >
                      <div
                        className={`flex flex-col lg:flex-row  border-b border-solid border-primary-bg  mx-margin-md Qlg:mx-margin-base `}
                      >
                        <div
                          className={`${typePopup ? "lg:w-width-md" : "lg:w-width-md w-auto"} Qlg:px-padding-base justify-between flex flex-row gap-x-gap-sm items-center py-padding-sm pl-padding-base  px-padding-base  Qlg:flex-shrink-0 flex-1`}
                        >
                          <div className="flex flex-col justify-start gap-y-gap-xs lg:pl-padding-sm">
                            <div className="flex flex-row gap-x-gap-xs relative">
                              <div>
                                <TitleSubtitlePair
                                  title={`₹ ${formatCurrency(account?.total_amount)}`}
                                  titleColor="settled"
                                  subtitle="Amount"
                                  info={true}
                                  onClick={showAmountInfo}
                                  alignRight={false}
                                  hoverOption="white"
                                  isBold={true}
                                  variant="md"
                                />
                              </div>

                              {infoBox && (
                                <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
                                  <CommonInfoBox
                                    headerTitle="Amount Breakdown"
                                    transactionAmount={account?.total_amount}
                                    transactionAmountColor={"settled"}
                                    transactionLabel="Transaction amount"
                                    finalAmountLabel="Amount credited"
                                    rows={[
                                      {
                                        label: "Amount debited",
                                        value: account?.total_amount,
                                        icon: ICONS?.SUBTRACTION_WITH_ROUNDNESS,
                                      },
                                      {
                                        label: "Tax amount",
                                        value: account?.tax_amount,
                                        icon: ICONS?.SUBTRACTION_WITH_ROUNDNESS,

                                        operation: "subtract",
                                      },
                                      {
                                        label: "Payment charge",
                                        value: account?.payment_charge,

                                        operation: "subtract",
                                      },
                                    ]}
                                    headerFontColor="text-primary"
                                    headerFontWeight="semibold"
                                    textSize="font-md"
                                    onClosepop={() => setInfoBox(null)}
                                    popupBgColor="primary-bg"
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="lg:mr-margin-sm flex justify-end pr-padding-sm gap-y-gap-xs text-right min-w-0 break-all flex-wrap">
                            <TitleSubtitlePair
                              isDisabled={false}
                              alignRight={true}
                              textAlign="right"
                              title={
                                account?.distribution_utr
                                  ? account?.distribution_utr
                                  : "N/A"
                              }
                              titleColor={"text-primary"}
                              subtitle={TEXT?.UTR_NUMBER}
                              info={false}
                              showArrow={false}
                              isBold={false}
                              variant={"md"}
                            />
                          </div>
                        </div>

                        <div className="border-r border-solid border-primary-bg my-margin-md hidden lg:block"></div>
                        <div className="flex flex-row justify-between lg:justify-start gap-x-gap-md w-width-full lg:w-width-md py-padding-md Qlg:py-padding-md  px-padding-base lg:px-padding-base border-t lg:border-none border-solid border-primary-bg flex-1">
                          <div className="gap-y-gap-xs lg:pl-padding-md">
                            <div>
                              <TitleSubtitlePair
                                title={account?.tds_account_name?.toLowerCase()}
                                titleColor="text-primary"
                                subtitle={TEXT?.ACCOUNT_NAME}
                                info={false}
                                alignRight={false}
                                hoverOption="white"
                                isBold={false}
                                variant="md"
                                titleCase="title"
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          className=" hidden lg:block"
                          style={{
                            visibility: "hidden",
                          }}
                        >
                          <TopNavSmallButton
                            btnText={""}
                            btnType="button"
                            handleFunction={() => {}}
                            isDisabled={typePopup}
                            enabledTextColor="var(--text-primary)"
                            enabledBgColor="var(--primary-nav-act)"
                            disabledBgColor="var(--primary-nav-act)"
                            hoverOption="white"
                            fullWidthRequired={false}
                          />
                        </div>
                        <div
                          className={`${account?.confidential_transaction === "Y" ? "hidden lg:block" : " hidden"}`}
                        >
                          <TopNavSmallButton
                            btnText={
                              <>
                                {TEXT?.CONFIDENTIAL}
                                <br />
                                {TEXT?.TRANSACTION}
                              </>
                            }
                            btnType="button"
                            icon={ICONS?.CONFIDENTIAL_TRANSACTION}
                            handleFunction={() => {
                              setIsCategoryName("");
                              setTaxAccId(viewTxnDetails[0]?.tds_account_id);
                              if (typePopup) {
                                actionRestricted();
                              } else {
                                openTransactionHistory();
                              }
                            }}
                            isDisabled={typePopup}
                            enabledTextColor="var(--text-primary)"
                            enabledBgColor="var(--primary-nav-act)"
                            disabledBgColor="var(--primary-nav-act)"
                            hoverOption="white"
                            fullWidthRequired={false}
                          />
                        </div>
                      </div>

                      <div className="relative mx-margin-sm Qlg:mx-margin-base">
                        <div className="flex flex-col justify-between lg:flex-row  lg:gap-gap-base h-auto lg:h-auto w-width-full">
                          <div
                            className={`flex flex-row lg:mr-margin-md  lg:pt-padding-sm w-width-full lg:w-width-md justify-between lg:h-height-md ${typePopup ? "lg:px-padding-base pr-padding-base pl-padding-base" : "lg:pl-padding-base pl-padding-base  lg:pr-padding-base pr-padding-base "}`}
                          >
                            <div
                              className={`${
                                !services?.includes("VAccount") || typePopup
                                  ? "p-padding-base pl-padding-base"
                                  : "py-padding-sm lg:py-padding-base"
                              } `}
                            >
                              <TitleSubtitlePair
                                isDisabled={
                                  typePopup || !services?.includes("VAccount")
                                    ? true
                                    : false
                                }
                                alignRight={false}
                                title={formatAccountNumber(
                                  account?.owner_account_bank_acc_no,
                                )}
                                titleColor={"text-primary"}
                                subtitle={TEXT?.SOURCE_ACCOUNT}
                                onClick={() => {
                                  if (!services?.includes("VAccount")) {
                                    navigate("/feature_not_assigned", {
                                      state: {
                                        unavailableService: "VAccount",
                                      },
                                    });
                                    return;
                                  }

                                  if (typePopup) {
                                    actionRestricted();
                                  } else {
                                    setOwnerDetailpop(true);
                                  }
                                }}
                                info={false}
                                showArrow={true}
                                hoverOption={"white"}
                                isBold={false}
                                variant={"md"}
                              />
                            </div>
                            <div className="bg-text-primary rounded-border-radius-md flex items-center justify-around h-toggle-btn-height px-padding-sm mt-margin-lg lg:mt-margin-md lg:mr-margin-md mr-margin-sm Qlg:ml-margin-sm ">
                              <CommonBankLogo
                                ifsc={account?.owner_account_ifsc_code}
                                variant="big"
                                type="pill"
                              />
                            </div>
                          </div>
                          <div className="Icode lg:hidden flex flex-col gap-y-gap-xs border-t border-primary-bg pl-padding-sm py-padding-md">
                            <TitleSubtitlePair
                              isDisabled={false}
                              alignRight={false}
                              title={account?.owner_account_ifsc_code}
                              titleColor={"text-primary"}
                              subtitle={TEXT?.IFSC_CODE}
                              info={false}
                              showArrow={false}
                              isBold={false}
                              variant={"md"}
                            />
                          </div>

                          <div className="flex items-center gap-gap-sm justify-start Qlg:px-padding-md Qlg:hidden mx-margin-sm Qlg:mx-margin-base">
                            <div className="w-width-md border-b border-primary-bg"></div>
                            <div className="w-icon-md">
                              <img
                                src={ICONS?.ARROW_DOWN_BLUE_WHITE}
                                alt="arrowDownBlueWhite"
                              />
                            </div>
                            <div className="w-width-md border-b border-primary-bg"></div>
                          </div>

                          <div
                            className={`border-r border-solid border-primary-bg  h-auto my-margin-lg hidden lg:block ${typePopup ? "mt-margin-sm" : "mt-margin-md"}`}
                          ></div>

                          <div
                            className={`flex flex-row lg:mt-margin-sm  w-width-full lg:w-width-md justify-between lg:h-height-md Qlg:mb-margin-base mb-margin-sm ${typePopup ? "lg:px-padding-base pr-padding-base pl-padding-base" : "lg:pl-padding-base pl-padding-base  lg:pr-padding-base pr-padding-base "}`}
                          >
                            <div
                              className={`${
                                !services?.includes("VAccount") || typePopup
                                  ? "p-padding-base Qlg:pl-padding-sm pl-padding-base"
                                  : "Qlg:pl-padding-sm pl-padding-base"
                              } `}
                            >
                              <TitleSubtitlePair
                                isDisabled={typePopup ? true : false}
                                alignRight={false}
                                title={formatAccountNumber(
                                  account?.tds_account_bank_acc_no,
                                )}
                                titleColor={"text-primary"}
                                subtitle={TEXT.DESTINATION_ACCOUNT}
                                onClick={() => handleBeneAccountClick()}
                                info={false}
                                showArrow={true}
                                hoverOption={"white"}
                                isBold={false}
                                variant={"md"}
                              />
                            </div>

                            <div className="bg-text-primary rounded-border-radius-md flex items-center justify-around h-toggle-btn-height px-padding-sm mt-margin-md lg:mr-margin-md mr-margin-sm Qlg:ml-margin-sm ">
                              <CommonBankLogo
                                ifsc={account?.tds_account_ifsc_code}
                                variant="big"
                                type="pill"
                              />
                            </div>
                          </div>
                          <div className=" border-t border-primary-bg mx-margin-sm "></div>
                          <div className="Icode lg:hidden flex flex-col gap-y-gap-xs pl-padding-sm py-padding-md">
                            <TitleSubtitlePair
                              isDisabled={false}
                              alignRight={false}
                              title={account?.tds_account_ifsc_code}
                              titleColor={"text-primary"}
                              subtitle={TEXT?.IFSC_CODE}
                              info={false}
                              showArrow={false}
                              isBold={false}
                              variant={"md"}
                            />
                          </div>

                          <div className="hidden lg:flex flex-col justify-end gap-gap-base mr-margin_margin-md ml-margin-base">
                            <div
                              className={`lg:flex flex-row  overflow-hidden justify-end h-auto w-auto ${
                                hasConfidential &&
                                tdsTransactionDetailsData?.transaction[0]
                                  ?.confidential_transaction === "Y"
                                  ? "bg-primary-nav-act"
                                  : ""
                              }`}
                            >
                              {hasConfidential &&
                              tdsTransactionDetailsData?.transaction[0]
                                ?.confidential_transaction === "Y" ? (
                                <div className="border-b solid border-primary-bg">
                                  <TopNavSmallButton
                                    btnText={
                                      <>
                                        {TEXT?.CONFIDENTIAL}
                                        <br />
                                        {TEXT?.TRANSACTION}
                                      </>
                                    }
                                    btnType="button"
                                    icon={ICONS?.CONFIDENTIAL_TRANSACTION}
                                    handleFunction={() => {
                                      setIsCategoryName("");
                                      setTaxAccId(
                                        viewTxnDetails[0]?.tds_account_id,
                                      );
                                      if (typePopup) {
                                        actionRestricted();
                                      } else {
                                        openTransactionHistory();
                                      }
                                    }}
                                    isDisabled={typePopup}
                                    enabledTextColor="var(--text-primary)"
                                    enabledBgColor="var(--primary-nav-act)"
                                    disabledBgColor="var(--primary-nav-act)"
                                    hoverOption="white"
                                    fullWidthRequired={false}
                                  />
                                </div>
                              ) : (
                                <div className="w-positive-negative-btn-width px-padding-xl ml-margin-lg py-padding-md box-border hidden" />
                              )}

                              <div className="border-b solid border-primary-bg bg-primary-nav-act">
                                <TopNavSmallButton
                                  btnText={viewTxnDetails[0]?.category}
                                  btnType="button"
                                  icon={categoryMapper(
                                    viewTxnDetails[0]?.category,
                                  )}
                                  handleFunction={() => {
                                    setTaxAccId(
                                      viewTxnDetails[0]?.tds_account_id,
                                    );
                                    setIsCategoryName(
                                      viewTxnDetails[0]?.category,
                                    );

                                    if (typePopup) {
                                      actionRestricted();
                                    } else {
                                      openTransactionHistory();
                                    }
                                  }}
                                  isDisabled={typePopup}
                                  enabledTextColor="var(--text-primary)"
                                  enabledBgColor="var(--primary-nav-act)"
                                  disabledBgColor="var(--primary-nav-act)"
                                  hoverOption="white"
                                  fullWidthRequired={false}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        className={`border-primary-bg border-solid border-t 
                          
                        Qlg:border-b flex flex-col h-auto items-center justify-between lg:border-none lg:flex-col lg:px-padding-base Qlg:w-width-full mx-margin-md Qlg:mx-margin-base ${account?.beneficiary_account_approval_status === "pending" ? "border-b border-primary-bg mx Qlg:border-none" : ""}`}
                      >
                        <div className="flex flex-row h-auto items-center justify-between lg:border-none lg:flex-row lg:px-padding-base  w-width-full">
                          <div className="w-width-full flex flex-row h-auto items-center justify-between lg:border-none lg:flex-row lg:px-padding-base px-padding-base relative">
                            <div className="parent flex flex-row py-padding-md lg:py-padding-base w-full Qlg:w-width-md lg:justify-between justify-end gap-gap-sm">
                              <div className="Icode lg:flex flex-col gap-y-gap-xs hidden mr-margin-xl lg:pl-padding-sm">
                                <TitleSubtitlePair
                                  isDisabled={false}
                                  alignRight={false}
                                  title={account?.owner_account_ifsc_code}
                                  titleColor={"text-primary"}
                                  subtitle={TEXT?.IFSC_CODE}
                                  info={false}
                                  showArrow={false}
                                  isBold={false}
                                  variant={"md"}
                                />
                              </div>

                              <div className="Qlg:hidden payment flex flex-col gap-y-gap-xs item-start ml-margin-lg mr-margin-md">
                                <TitleSubtitlePair
                                  isDisabled={false}
                                  alignRight={false}
                                  title={
                                    account?.distribution_mode_of_payment ||
                                    account?.payment_method ||
                                    "N/A"
                                  }
                                  titleColor={"text-primary"}
                                  subtitle={TEXT?.PAYMENT_METHOD}
                                  info={false}
                                  showArrow={false}
                                  isBold={false}
                                  variant={"md"}
                                />
                              </div>
                              <div
                                className={`payment hidden Qlg:flex flex-col  gap-y-gap-xs items-end item-start ml-margin-lg mr-margin-md`}
                              >
                                <TitleSubtitlePair
                                  isDisabled={false}
                                  alignRight={true}
                                  textAlign={"right"}
                                  title={
                                    account?.distribution_mode_of_payment ||
                                    account?.payment_method ||
                                    "N/A"
                                  }
                                  titleColor={"text-primary"}
                                  subtitle={TEXT?.PAYMENT_METHOD}
                                  info={false}
                                  showArrow={false}
                                  isBold={false}
                                  variant={"md"}
                                />
                              </div>
                            </div>

                            <div className="border-primary-bg border-r border-solid hidden lg:block  py-padding-md"></div>
                            <div
                              className="lg:flex justify-center items-center hidden z-z-index-content absolute bottom-stepper-gap-between"
                              style={{
                                left: "calc(var(--top-half) - var(--top-sm) )",
                              }}
                            >
                              <img
                                src={ICONS?.ARROW_RIGHT_BLUE_CIRCLE}
                                className="w-icon-md h-icon-md"
                                alt="Transaction"
                              />
                            </div>
                            <div className="flex flex-row justify-between items-center gap-x-gap-md lg:gap-x-gap-xl pr-padding-md lg:pr-padding-base w-width-full lg:w-width-md">
                              <div className="hidden lg:flex flex-col justify-start items-start gap-y-gap-xs py-padding-sm mr-margin-xl ml-margin-md">
                                <TitleSubtitlePair
                                  isDisabled={false}
                                  alignRight={false}
                                  title={account?.tds_account_ifsc_code}
                                  titleColor={"text-primary"}
                                  subtitle={TEXT?.IFSC_CODE}
                                  info={false}
                                  showArrow={false}
                                  isBold={false}
                                  variant={"md"}
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            className={`hidden lg:flex flex-row justify-end align-bottom h-auto `}
                          >
                            <div>
                              <TopNavSmallButton
                                btnText={
                                  <>
                                    {TEXT?.TRANSACTION}
                                    <br />
                                    {TEXT?.HISTORY}
                                  </>
                                }
                                btnType="button"
                                icon={ICONS?.TRANSACTION_HISTORY}
                                handleFunction={() => {
                                  setTaxAccId(account?.tds_account_id);
                                  setIsCategoryName("");
                                  if (typePopup) {
                                    actionRestricted();
                                  } else {
                                    openTransactionHistory();
                                  }
                                }}
                                isDisabled={typePopup}
                                enabledTextColor="var(--text-primary)"
                                enabledBgColor="var(--primary-nav-act)"
                                disabledBgColor="var(--primary-nav-act)"
                                hoverOption="white"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="bg-primary-bg Qlg:hidden block Qlg:border-none border-primary-bg">
                <div className="flex flex-col w-width-full max-w-tab-width-normal m-auto">
                  <TimelineStatusBar
                    showMobile={true}
                    overrideAutoLoader
                    whichBtnClicked={
                      btnClicked?.[viewTxnDetails?.[0]?.txn_id] || "none"
                    }
                    isLoading={loading}
                    approvalNotPossible={
                      networkError ||
                      errorMessage ||
                      viewTxnDetails?.[0]?.message
                    }
                    approvalNotPossibleIcon={true}
                    rejected={
                      viewTxnDetails?.[0]?.lifecycle_status === "rejected"
                    }
                    rejectedReason={
                      viewTxnDetails?.[0]?.rejection_reason?.length > 150
                        ? viewTxnDetails?.[0]?.rejection_reason.slice(0, 150) +
                          "..."
                        : viewTxnDetails?.[0]?.rejection_reason
                    }
                    accountApprovalPending={
                      viewTxnDetails?.[0]?.tds_account_approval_status ===
                        "pending" &&
                      viewTxnDetails?.[0]?.lifecycle_status === "pending"
                    }
                    accountApprovalPendingSubHeader={
                      services?.includes("BTDSAccount")
                        ? "Account is not approved, approve account before approving transaction."
                        : "To approve the account, please contact the authorized person."
                    }
                    handleApprovalPendingBtn={() =>
                      services?.includes("BTDSAccount")
                        ? setTaxAccountDetailpop(true)
                        : navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "BTDSAccount",
                            },
                          })
                    }
                    isApprovalPendingDisabled={
                      !services?.includes("BTDSAccount")
                    }
                    furtherApprovalPending={
                      viewTxnDetails?.[0]?.lifecycle_status === "pending" &&
                      viewTxnDetails?.[0]?.approved === "N" &&
                      viewTxnDetails?.[0]?.logs[
                        viewTxnDetails?.[0]?.logs.length -
                          GlobalConfiguration?.lengthCheckOne
                      ]?.action?.toLowerCase() === "approved" &&
                      viewTxnDetails?.[0]?.logs[
                        viewTxnDetails?.[0]?.logs.length -
                          GlobalConfiguration?.lengthCheckOne
                      ]?.user_id === loginid?.employees?.id &&
                      viewTxnDetails?.[0]?.final_approval !== true
                    }
                    furtherApprovalPendingSubHeader={
                      "This transaction has been approved by you, but it requires another user's approval before settlement."
                    }
                    pending={
                      viewTxnDetails?.[0]?.tds_account_approval_status ===
                        "approved" &&
                      viewTxnDetails?.[0]?.lifecycle_status === "pending"
                    }
                    rejectMobClick={() => {
                      if (services?.includes("ATDSTransaction")) {
                        setbtnClicked((prev) => ({
                          ...prev,
                          [viewTxnDetails?.[0]?.txn_id]: "Reject",
                        }));
                        handleDeclinedDetails(viewTxnDetails?.[0]?.txn_id);
                      } else {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "ATDSTransaction",
                          },
                        });
                      }
                    }}
                    isRejectMobDisable={
                      services?.includes("ATDSTransaction") ? false : true
                    }
                    approveMobClick={() => {
                      if (services?.includes("ATDSTransaction")) {
                        setbtnClicked((prev) => ({
                          ...prev,
                          [viewTxnDetails?.[0]?.txn_id]: "Approve",
                        }));
                        handleApproveTransaction(viewTxnDetails?.[0]?.txn_id);
                      } else {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "ATDSTransaction",
                          },
                        });
                      }
                    }}
                    isApproveMobDisable={
                      services?.includes("ATDSTransaction") ? false : true
                    }
                  />

                  <div className="flex flex-col w-width-full my-margin-md">
                    <div className="py-padding-sm px-padding-md bg-primary-card text-font-sm text-text-primary text-left font-semibold w-width-full">
                      Quick Action
                    </div>

                    <div
                      className={` ${
                        hasConfidential &&
                        tdsTransactionDetailsData?.transaction[0]
                          ?.confidential_transaction === "Y"
                          ? "grid grid-cols-2"
                          : ""
                      }  w-width-full bg-primary-nav border-b border-primary-bg`}
                    >
                      <div className="relative">
                        {hasConfidential &&
                          tdsTransactionDetailsData?.transaction[0]
                            ?.confidential_transaction === "Y" && (
                            <TopNavSmallButton
                              btnText={
                                <>
                                  {TEXT?.CONFIDENTIAL} <br />{" "}
                                  {TEXT?.TRANSACTION}
                                </>
                              }
                              btnType="button"
                              icon={ICONS?.CONFIDENTIAL_TRANSACTION}
                              handleFunction={() => {
                                setIsCategoryName("");
                                setTaxAccId("");
                                if (typePopup) {
                                  actionRestricted();
                                } else {
                                  openTransactionHistory();
                                }
                              }}
                              isDisabled={typePopup}
                              enabledTextColor="var(--text-primary)"
                              enabledBgColor="var(--primary-nav-act)"
                              disabledBgColor="var(--primary-nav-act)"
                              hoverOption="white"
                              fullWidthRequired={true}
                            />
                          )}
                        <div className="absolute top-top-base right-right-base h-height-full border-r border-primary-bg"></div>
                      </div>

                      <TopNavSmallButton
                        btnText={viewTxnDetails[0]?.category}
                        btnType="button"
                        icon={categoryMapper(viewTxnDetails[0]?.category)}
                        handleFunction={() => {
                          setTaxAccId(viewTxnDetails[0]?.tds_account_id);
                          setIsCategoryName(viewTxnDetails[0]?.category);
                          if (typePopup) {
                            actionRestricted();
                          } else {
                            openTransactionHistory();
                          }
                        }}
                        isDisabled={typePopup}
                        enabledTextColor="var(--text-primary)"
                        enabledBgColor="var(--primary-nav-act)"
                        disabledBgColor="var(--primary-nav-act)"
                        hoverOption="white"
                        fullWidthRequired={true}
                      />
                    </div>
                    <div
                      className={`grid w-width-full bg-primary-nav ${
                        hasConfidential &&
                        tdsTransactionDetailsData?.transaction[0]
                          ?.confidential_transaction === "Y"
                          ? "grid-cols-2"
                          : "grid-cols-1"
                      } border-b border-primary-bg`}
                    >
                      <div className="relative">
                        <TopNavSmallButton
                          btnText={
                            <>
                              {TEXT?.TRANSACTION}
                              <br />
                              {TEXT?.HISTORY}
                            </>
                          }
                          btnType="button"
                          icon={ICONS?.TRANSACTION_HISTORY}
                          handleFunction={() => {
                            setTaxAccId(viewTxnDetails[0]?.tds_account_id);
                            setIsCategoryName("");
                            if (typePopup) {
                              actionRestricted();
                            } else {
                              openTransactionHistory();
                            }
                          }}
                          isDisabled={typePopup}
                          disabledBgColor="var(--primary-nav-act)"
                          enabledTextColor="var(--text-primary)"
                          enabledBgColor="var(--primary-nav-act)"
                          hoverOption="white"
                          fullWidthRequired={true}
                        />
                        {/* {hasConfidential &&
                          tdsTransactionDetailsData?.transaction[0]
                            ?.confidential_transaction === "Y" && (
                            <div className="absolute top-top-base right-right-base h-height-full border-r border-primary-bg"></div>
                          )} */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex-row w-width-full timeline_box max-w-tab-width-normal m-auto flex items-end">
                <div
                  className={` ${
                    viewTxnDetails?.[0]?.tds_account_approval_status ===
                      "approved" &&
                    viewTxnDetails?.[0]?.lifecycle_status === "approved"
                      ? ""
                      : " Qsmd:bg-primary-card"
                  } flex flex-col w-full lg:w-width-md mx-margin-md lg:mx-margin-base h-auto mt-margin-md  overflow-hidden relative rounded-bl-border-radius-md rounded-t-border-radius-md
                     ${
                       tdsTransactionDetailsData?.transaction?.[
                         GlobalConfiguration.lengthCheckZero
                       ]?.distribution_lifecycle_status !== "created" &&
                       viewTxnDetails?.[GlobalConfiguration.lengthCheckZero]
                         ?.lifecycle_status === "rejected" &&
                       viewTxnDetails?.[GlobalConfiguration.lengthCheckZero]
                         ?.lifecycle_status === "pending" &&
                       tdsTransactionDetailsData?.transaction?.[
                         GlobalConfiguration.lengthCheckZero
                       ]?.distribution_lifecycle_status !==
                         "distribution_complete"
                         ? "rounded-bl-border-radius-md Qlg:rounded-br-none rounded-br-border-radius-md"
                         : (viewTxnDetails?.[
                               GlobalConfiguration.lengthCheckZero
                             ]?.beneficiary_account_approval_status ===
                               "approved" &&
                               tdsTransactionDetailsData?.transaction?.[
                                 GlobalConfiguration.lengthCheckZero
                               ]?.distribution_lifecycle_status ===
                                 "created") ||
                             tdsTransactionDetailsData?.transaction?.[
                               GlobalConfiguration.lengthCheckZero
                             ]?.distribution_lifecycle_status ===
                               "distribution_complete" ||
                             tdsTransactionDetailsData?.transaction?.[
                               GlobalConfiguration.lengthCheckZero
                             ]?.distribution_lifecycle_status === "approved" ||
                             tdsTransactionDetailsData?.transaction?.[
                               GlobalConfiguration.lengthCheckZero
                             ]?.distribution_lifecycle_status ===
                               "awaiting_funds" ||
                             tdsTransactionDetailsData?.transaction?.[
                               GlobalConfiguration.lengthCheckZero
                             ]?.distribution_lifecycle_status ===
                               "distribution_initiated"
                           ? "rounded-b-border-radius-md"
                           : "rounded-bl-border-radius-md rounded-br-none"
                     }
  
                  `}
                >
                  <div
                    className={`flex flex-col w-full  h-auto   ${
                      viewTxnDetails?.[0]
                        ?.beneficiary_account_approval_status === "approved" &&
                      viewTxnDetails?.[0].lifecycle_status === "pending"
                        ? " rounded-bl-border-radius-md  rounded-br-border-radius-md"
                        : "rounded-b-border-radius-md"
                    } rounded-t-border-radius-md overflow-hidden relative`}
                  >
                    {/* TITLE */}
                    <div className="pt-px bg-primary-nav rounded-tl-border-radius-md px-padding-md rounded-tr-border-radius-md">
                      <p className="text-text-primary text-font-xs text-left font-semibold my-margin-sm">
                        Transaction Timeline
                      </p>
                      <div className="border border-primary-bg"></div>
                    </div>

                    <div ref={leftContentRef}>
                      <CommonTimeLineCard
                        logsData={viewTxnDetails}
                        handleApprovalClick={handleTimelinePopup}
                        handleDistributionClick={handleDistributionClick}
                        showApprovalTimeline={showApprovalTimeline}
                        showDistributionTimeline={showDistributionTimeline}
                        showDistributionRightIcon={true}
                        showApprovalLeftIcon={true}
                        isDisabled={typePopup ? true : false}
                        cardType={"double"}
                      />
                    </div>
                  </div>
                </div>

                <div className="hidden lg:flex flex-col flex-grow mt-margin-md w-width-md">
                  {/* Web Timeline status  */}
                  <TimelineStatusBar
                    showMobile={false}
                    overrideAutoLoader
                    isLoading={loading}
                    whichBtnClicked={
                      btnClicked?.[viewTxnDetails?.[0]?.txn_id] || "none"
                    }
                    approvalNotPossible={
                      networkError ||
                      errorMessage ||
                      viewTxnDetails?.[0]?.message
                    }
                    approvalNotPossibleIcon={true}
                    rejected={
                      viewTxnDetails?.[0]?.lifecycle_status === "rejected"
                    }
                    rejectedReason={
                      viewTxnDetails?.[0]?.rejection_reason?.length > 150
                        ? viewTxnDetails?.[0]?.rejection_reason.slice(0, 150) +
                          "..."
                        : viewTxnDetails?.[0]?.rejection_reason
                    }
                    accountApprovalPending={
                      viewTxnDetails?.[0]?.tds_account_approval_status ===
                        "pending" &&
                      viewTxnDetails?.[0]?.lifecycle_status === "pending"
                    }
                    accountApprovalPendingSubHeader={
                      services?.includes("BTDSAccount")
                        ? "Account is not approved, approve account before approving transaction."
                        : "To approve the account, please contact the authorized person."
                    }
                    handleApprovalPendingBtn={() =>
                      services?.includes("BTDSAccount")
                        ? setTaxAccountDetailpop(true)
                        : navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "BTDSAccount",
                            },
                          })
                    }
                    isApprovalPendingDisabled={
                      !services?.includes("BTDSAccount")
                    }
                    furtherApprovalPending={
                      viewTxnDetails?.[0]?.lifecycle_status === "pending" &&
                      viewTxnDetails?.[0]?.approved === "N" &&
                      viewTxnDetails?.[0]?.logs[
                        viewTxnDetails?.[0]?.logs.length -
                          GlobalConfiguration?.lengthCheckOne
                      ]?.action?.toLowerCase() === "approved" &&
                      viewTxnDetails?.[0]?.logs[
                        viewTxnDetails?.[0]?.logs.length -
                          GlobalConfiguration?.lengthCheckOne
                      ]?.user_id === loginid?.employees?.id &&
                      viewTxnDetails?.[0]?.final_approval !== true
                    }
                    furtherApprovalPendingSubHeader={
                      "This transaction has been approved by you, but it requires another user's approval before settlement."
                    }
                    pending={
                      viewTxnDetails?.[0]?.tds_account_approval_status ===
                        "approved" &&
                      viewTxnDetails?.[0]?.lifecycle_status === "pending"
                    }
                    rejectClick={() => {
                      if (services?.includes("ATDSTransaction")) {
                        setbtnClicked((prev) => ({
                          ...prev,
                          [viewTxnDetails?.[0]?.txn_id]: "Reject",
                        }));
                        handleDeclinedDetails(viewTxnDetails?.[0]?.txn_id);
                      } else {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "ATDSTransaction",
                          },
                        });
                      }
                    }}
                    isRejectDisable={
                      services?.includes("ATDSTransaction") ? false : true
                    }
                    approveClick={() => {
                      if (services?.includes("ATDSTransaction")) {
                        setbtnClicked((prev) => ({
                          ...prev,
                          [viewTxnDetails?.[0]?.txn_id]: "Approve",
                        }));
                        handleApproveTransaction(viewTxnDetails?.[0]?.txn_id);
                      } else {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "ATDSTransaction",
                          },
                        });
                      }
                    }}
                    isApproveDisable={
                      services?.includes("ATDSTransaction") ? false : true
                    }
                  />
                </div>
              </div>

              <div
                className={`details-div-trans lg:mb-margin-md bg-primary-bg pt-padding-sm lg:pt-padding-base pb-padding-xl ${
                  typePopup ? "w-width-full" : "w-screen"
                }`}
              >
                <div className="detail-section-trans h-auto bg-primary-bg m-auto max-w-tab-width-normal">
                  <div className="mt-margin-md flex">
                    <div className="flex gap-gap-sm bg-primary-card w-auto ml-margin-md lg:ml-margin-base rounded-border-radius-md overflow-x-auto">
                      <SwitcherTabs
                        initialActiveTab={
                          showAdditionalDetails
                            ? "Additional details"
                            : "details"
                        }
                        tabs={[
                          {
                            label: "Details",
                            key: "details",
                            handler: toggleDetails,
                          },
                          {
                            label: "Additional details",
                            key: "Additional details",
                            handler: toggleAdditionalDetails,
                          },
                          {
                            label: "Labels",
                            key: "Assigned Labels",
                            handler: toggleAssignedLabels,
                          },
                        ]}
                        setIndex={setIndex}
                      />
                    </div>
                  </div>
                  <div className="relative">
                    {index === GlobalConfiguration?.lengthCheckZero && (
                      <div className={animationClass}>
                        {viewTxnDetails?.map((account) => {
                          let originItemList = [
                            {
                              content:
                                `${account?.logs?.[0]?.first_name ?? ""} ${account?.logs?.[0]?.last_name ?? ""}`
                                  .toLowerCase()
                                  .replace(/\b\w/g, (c) => c.toUpperCase()),
                              heading: "Created by",
                              type: "text",
                            },
                            {
                              content: formatDateViewAll(
                                account?.created_on,
                                true,
                                true,
                              ),
                              heading: "Created on",
                              type: "text",
                            },
                          ];
                          if (account?.created_via) {
                            originItemList.push({
                              content: account?.created_via ?? "",
                              heading: "Created via",
                              type: "text",
                            });
                          }

                          let settlementItemList = [];
                          if (
                            account?.distribution_lifecycle_status ===
                            "distribution_complete"
                          ) {
                            settlementItemList = [
                              {
                                content: account?.distribution_credited_at
                                  ? ISO_DataFormatter(
                                      account?.distribution_credited_at,
                                    )
                                  : "N/A",
                                heading: "Settled on",
                                type: "text",
                              },
                              {
                                content: account?.distribution_settlement_id
                                  ? account?.distribution_settlement_id
                                  : "N/A",
                                heading: "Settlement ID",
                              },
                            ];
                          }

                          let supportItemList = [
                            {
                              content: account.txn_id,
                              heading: "Transaction ID",
                              type: "text",
                            },
                          ];
                          return (
                            <div
                              className={`flex flex-col lg:flex-row my-margin-md px-padding-md lg:px-padding-base ${
                                account?.distribution_lifecycle_status ===
                                "distribution_complete"
                                  ? "justify-between gap-gap-md"
                                  : "gap-gap-md lg:gap-gap-md"
                              }`}
                            >
                              <CommonDetailCard
                                cardTitle={TEXT?.ORIGIN_DETAILS}
                                variant="third"
                                numCols={GlobalConfiguration?.lengthCheckOne}
                                entries={originItemList}
                              />
                              {account?.distribution_lifecycle_status ===
                                "distribution_complete" && (
                                <CommonDetailCard
                                  cardTitle={TEXT?.SETTLEMENT_DETAILS}
                                  numCols={GlobalConfiguration?.lengthCheckOne}
                                  variant="third"
                                  entries={settlementItemList}
                                />
                              )}
                              <CommonDetailCard
                                cardTitle={TEXT?.SUPPORT_INFORMATION}
                                numCols={GlobalConfiguration?.lengthCheckOne}
                                variant="third"
                                entries={supportItemList}
                              />
                            </div>
                          );
                        })}
                      </div>
                    )}

                    {index === GlobalConfiguration?.lengthCheckOne && (
                      <div className={animationClass}>
                        <div className="flex flex-col lg:flex-row items-start gap-gap-md pb-padding-md text-text-primary mt-margin-md px-padding-md lg:px-padding-base">
                          <>
                            {validItems?.filter(
                              (item) =>
                                item.name !== "Hyperlink" &&
                                item.name !== "File" &&
                                item.name !== "Image",
                            ).length ===
                            GlobalConfiguration?.lengthCheckZero ? (
                              <div className="w-details-card-md flex flex-col p-padding-md gap-gap-md bg-primary-card rounded-border-radius-md">
                                <div className="text-text-primary text-font-sm font-semibold">
                                  {TEXT?.ADDITIONAL_DETAILS}
                                </div>
                                <p className="text-text-secondary text-font-xs font-normal">
                                  Additional details are not supported for the
                                  selected category.
                                </p>
                              </div>
                            ) : (
                              <>
                                {(() => {
                                  const filteredItems = validItems?.filter(
                                    (item) =>
                                      item.data_type.toLowerCase() !==
                                        "hyperlink" &&
                                      item.data_type !== "File" &&
                                      item.data_type !== "Image" &&
                                      item.data_type !== "upload",
                                  );

                                  return (
                                    <>
                                      {!!filteredItems?.length && (
                                        <CommonDetailCard
                                          cardTitle={TEXT?.ADDITIONAL_DETAILS}
                                          numCols={
                                            filteredItems.length ===
                                            GlobalConfiguration?.lengthCheckOne
                                              ? GlobalConfiguration?.lengthCheckOne
                                              : GlobalConfiguration?.lengthCheckTwo
                                          }
                                          variant="third"
                                          entries={filteredItems.map(
                                            (subItem, index) => {
                                              switch (subItem.data_type) {
                                                case "toggle":
                                                  return {
                                                    content: subItem?.value
                                                      ? "Yes"
                                                      : "No",
                                                    heading: subItem?.name,
                                                    type: "text",
                                                  };
                                                case "multi_select_list":
                                                  return {
                                                    content:
                                                      subItem?.value?.length !==
                                                      GlobalConfiguration?.lengthCheckZero
                                                        ? subItem?.value?.join(
                                                            ", ",
                                                          )
                                                        : "Not Given",
                                                    heading: subItem?.name,
                                                    type: "text",
                                                  };
                                                case "date_range":
                                                  return {
                                                    content: subItem?.value
                                                      ?.start_date
                                                      ? `${subItem.value.start_date} - ${subItem.value.end_date}`
                                                      : "Not Given",
                                                    heading:
                                                      "From date - To date",
                                                    type: "text",
                                                  };
                                                case "from_year_to_year":
                                                  return {
                                                    content: subItem?.value
                                                      ?.from
                                                      ? `${subItem.value.from} - ${subItem.value.to}`
                                                      : "Not Given",
                                                    heading:
                                                      "From year - To year",
                                                    type: "text",
                                                  };
                                                default:
                                                  return {
                                                    content:
                                                      subItem?.value ??
                                                      "Not Given",
                                                    heading: subItem?.name,
                                                    type: "text",
                                                    onClick: undefined,
                                                  };
                                              }
                                            },
                                          )}
                                        />
                                      )}
                                    </>
                                  );
                                })()}
                              </>
                            )}
                          </>

                          {attachments?.length >
                            GlobalConfiguration?.lengthCheckZero && (
                            <>
                              <CommonDetailCard
                                cardTitle={TEXT?.ATTACHMENTS}
                                numCols={GlobalConfiguration?.lengthCheckOne}
                                variant="third"
                                entries={attachments.map((obj, index) => {
                                  switch (obj.data_type.toLowerCase()) {
                                    case "hyperlink":
                                      return {
                                        content: obj?.value ?? "#",
                                        heading: "URL",
                                        type: "link",
                                      };
                                    default: {
                                      let ob = obj.value;
                                      const mt =
                                        ob?.metadata?.mime_type ??
                                        "application/octet-stream";
                                      switch (true) {
                                        case mt?.startsWith("image/"):
                                          return {
                                            content: {
                                              fileName: ob?.metadata?.filename,
                                              size: ob?.metadata?.size ?? "0",
                                              mimeType: mt,
                                              url: ob?.file_url,
                                              onUrlClick: () => {
                                                setOpenImageUrl(true);
                                                setSelectedImage({
                                                  name: ob?.metadata?.filename,
                                                  url: ob?.file_url,
                                                });
                                              },
                                            },
                                            heading: "Image",
                                            type: "image",
                                          };
                                        default:
                                          return {
                                            content: {
                                              fileName: ob?.metadata?.filename,
                                              size: ob?.metadata?.size ?? "0",
                                              mimeType: mt,
                                              onUrlClick: () => {
                                                window
                                                  .open(ob?.file_url, "_blank")
                                                  .focus();
                                              },

                                              url: ob?.file_url,
                                            },
                                            heading: "File",
                                            type: "file",
                                          };
                                      }
                                    }
                                  }
                                })}
                              />
                            </>
                          )}
                        </div>
                      </div>
                    )}

                    {index === GlobalConfiguration?.lengthCheckTwo && (
                      <div className={animationClass}>
                        <div className="mt-margin-md">
                          <CommonContainerCard
                            header="Labels"
                            iconIsDisabled={
                              !(
                                services?.includes("ALabel") &&
                                services?.includes("RLabel")
                              ) || typePopup
                            }
                            subheader={TEXT?.LABELS_USAGE_NOTE}
                            icon={ICONS?.EDIT}
                            handleFunction={(e) => {
                              e.stopPropagation();

                              if (
                                !(
                                  services?.includes("ALabel") &&
                                  services?.includes("RLabel")
                                )
                              ) {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "ALabel,RLabel",
                                  },
                                });
                                return;
                              }

                              if (typePopup) {
                                actionRestricted();
                                return;
                              }

                              setShowLabelsPopup(true);
                            }}
                          >
                            <div className="flex flex-wrap w-width-full gap-gap-sm overflow-x-auto">
                              {Array.isArray(labelDetails) &&
                              labelDetails?.length ? (
                                <>
                                  {labelDetails?.map((item, index) => (
                                    <Chips
                                      key={index}
                                      txtChip={item}
                                      enabledBgColor="var(--primary-nav)"
                                      disableIcon={true}
                                      handleFunction={(e) => {
                                        e.stopPropagation();
                                        return;
                                      }}
                                      enabledTextColor="var(--text-primary)"
                                    />
                                  ))}
                                </>
                              ) : (
                                <p className="text-font-sm text-text-primary">
                                  No labels assigned.
                                </p>
                              )}
                            </div>
                          </CommonContainerCard>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>{" "}
    </>
  );
};

export default TaxationTransactionDetails;
